export default {"src":"/_next/static/media/hubspot.7baf9d77.svg","height":31,"width":106,"blurWidth":0,"blurHeight":0};